import { render, staticRenderFns } from "./BoxOpiniones.vue?vue&type=template&id=903033d4&scoped=true&lang=pug"
import script from "./BoxOpiniones.vue?vue&type=script&lang=js"
export * from "./BoxOpiniones.vue?vue&type=script&lang=js"
import style0 from "./BoxOpiniones.vue?vue&type=style&index=0&id=903033d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903033d4",
  null
  
)

export default component.exports